function ColorSelect({
  loading,
  Skeleton,
  selectedColor,
  selectedSize,
  setSelectedColor,
  setSelectedMedia,
  selectionColor,
}) {
  return (
    <div className="color-selector">
      {loading ? (
        <div style={{ display: "flex", gap: "10px" }}>
          {Array(5)
            .fill(0)
            .map((_, idx) => (
              <Skeleton key={idx} square height={30} width={30} />
            ))}
        </div>
      ) : (
        <>
          <div className="color-label-st">
            <p style={{marginBottom:"0"}}>
              Select Color :&nbsp;
              <span style={{ textTransform: "uppercase", fontWeight: "bold" }}>
                {selectedColor?.color}
              </span>
            </p>
          </div>

          <div className="color-options">
            {selectedSize?.product_colors?.map((color, idx) => (
              <div
                key={idx}
                className={`selected-color ${
                  selectedColor?.id === color.id ? "active-size" : ""
                }`}
                onClick={() => {
                  setSelectedColor(color);
                  selectionColor(color);

                  // MAIN FIX
                  if (color?.product_media?.length > 0) {
                    setSelectedMedia(color.product_media[0].media);
                  }
                }}
              >
                <div className="color-circle">
                  <img
                    src={color.color_media}
                    alt={color.color}
                    height={60}
                    width={60}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default ColorSelect;